<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout v-if="!loading" row wrap>
            <v-flex xs6><vue-plotly v-if="data" :white-mode="whiteMode" disable-responsive :data="data"
                                    :layout="layout" :options="{}"/></v-flex>
            <v-flex xs6><vue-plotly v-if="data2" :white-mode="whiteMode" disable-responsive :data="data2"
                                    :layout="layout2" :options="{}"/></v-flex>

        </v-layout>
    </div>
</template>

<script>
    import {getMaintenanceRecords} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import moment from "moment";
    export default {
        props: {
            title: {type: String, default: "Fixed Maintenance Records"},
            title2: {type: String, default: "New Maintenance Records"},
            height: {type: Number, default: 240},
            dateRange: {type: Object, default: null},
            whiteMode:{type:Boolean, default: false},
        },
        components: {LoadingProgressBar,VuePlotly},
        computed: {},
        name: 'MaintenanceSummaryWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                data2:null,
                layout:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
                layout2:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,200);
            },
            async getData(){
                if(this.dateRange){
                    this.loading=true
                    let df = await getMaintenanceRecords({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name
                    })
                    let fixedInRange=df.result.filter(x=>x.is_fixed&&moment(x.fixed_date).format('YYYY-MM-DD HH:mm:ss')>=moment(this.dateRange.start).format('YYYY-MM-DD HH:mm:ss')&&moment(x.fixed_date).format('YYYY-MM-DD HH:mm:ss')<=moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59").length
                    let caretedInRange=df.result.filter(x=>moment(x.created_on).format('YYYY-MM-DD HH:mm:ss')>=moment(this.dateRange.start).format('YYYY-MM-DD HH:mm:ss')&&moment(x.created_on).format('YYYY-MM-DD HH:mm:ss')<=moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59").length
                    this.data=[{
                        type:"indicator",
                        value:fixedInRange,
                        mode:"number",
                        title:{
                            text:this.title
                        }
                    }]
                    this.data2=[{
                        type:"indicator",
                        value:caretedInRange,
                        mode:"number",
                        title:{
                            text:this.title2
                        }
                    }]
                    this.loading=false
                }




            }
        },
    }
</script>
